import { AuthContext } from '@/context/AuthContext';
import './style.scss';
import { useContext } from 'react';

const MainHeader = () => {
  const { profileInfo } = useContext(AuthContext);
  const greeting = () => {
    const now = new Date();
    const hour = now.getHours();
    if (hour < 12) {
      return 'Good morning,';
    } else if (hour < 18) {
      return 'Good afternoon,';
    } else {
      return 'Good evening,';
    }
  };

  const getFirstName = (name: string) => {
    return name.split(' ')[0];
  };
  return (
    <div className="header-container mb-3">
      <div className="header-content">
        <div className="header-greeting">
          {greeting()} {getFirstName(profileInfo?.fullName ?? '')}
        </div>
        <h1 className="mb-0 header-greeting-1">How can I assist you today?</h1>
      </div>
    </div>
  );
};

export default MainHeader;
